import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initCacheClearing } from './utils/clearAppCache'

// Clear old caches to ensure fresh content (fixes stale logo issues)
initCacheClearing();

createRoot(document.getElementById("root")!).render(<App />);
